import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { SwiperComponent, SwiperDirective, SwiperConfigInterface,
  SwiperScrollbarInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { TotemService } from '../totem.service';
import { Publicidad } from './publicidad';
import { ActivatedRoute  } from '@angular/router';
import { from } from 'rxjs';
import { ControlPosition } from '@agm/core/services/google-maps-types';
import { DragScrollComponent } from 'ngx-drag-scroll';
import * as moment from 'moment';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {
  @ViewChild('ventanaPublicidad', {static: false}) ventanaPublicidad: ElementRef;
  @ViewChild('videopublicidad', {static: false}) videopublicidad: ElementRef;
  publicidades;
  rutavideo;
  estilovideo;
  public reload = false;
  indexActual = 0;
  index = 0;
  advertising;
  haypublicidad = true;
  next;
  actual;
  tipoPublicidad;
  segundosimagen = 10;
  config: SwiperConfigInterface =
  {
    a11y: true,
    direction: 'horizontal',
    observer: true,
    spaceBetween: 10,
    slidesPerView: 1,
    simulateTouch: true,
    allowTouchMove: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true
    };
  constructor(  private totemService: TotemService, private activatedRoute: ActivatedRoute) { }
  async ngOnInit() {
    await this.totemService.getpublicidades().subscribe(resp => {
      this.publicidades = resp;
      this.advertising = this.publicidades;
      console.log('pub', this.advertising);
      this.haypublicidad = this.publicidades !== undefined ? this.publicidades.length > 0 ? true : false : false;

      if (this.haypublicidad) {
        this.initpublicidad(this.publicidades);
      }
    });
  }
  initpublicidad(pub: any) {
    const listaPublicidades = [];
    for (const publicidad of pub) {
      if ( moment().isBetween(publicidad.fecha_inicio, publicidad.fecha_termino ) ) {
        listaPublicidades.push(publicidad);
      }
    }
    this.actual = listaPublicidades[0].multimedias[0];
    if (listaPublicidades.length === 1) {
      if (listaPublicidades[0].multimedias[0].nombre_tipo_multimedia === 'tipoMultimedia 2') {
        this.tipoPublicidad = 1;
      } else if (listaPublicidades[0].multimedias[0].nombre_tipo_multimedia === 'tipoMultimedia 1') {
        this.tipoPublicidad = 2;
      }
    } else {
      this.tipoPublicidad = 3;
      if (this.actual.nombre_tipo_multimedia === 'tipoMultimedia 1') {
        setTimeout(() => {
          this.nextAdvertising();
      }, this.segundosimagen * 1000);
      }
    }
  }

    nextAdvertising() {
      this.index++;
      if (this.index + 1 > this.advertising.length) {
        this.index = 0;
      }
      this.next = this.advertising[this.index].multimedias[0];
      this.actual = this.next;
      if (this.actual.nombre_tipo_multimedia === 'tipoMultimedia 1' ) {
        setTimeout(() => {
          this.nextAdvertising();
      }, this.segundosimagen * 1000);
      }
    }
}
